<template>
  <div class="sugerencias-publicas-container">
    <!-- Header -->
    <div class="header-public">
      <div class="container">
        <div class="text-center py-3">
          <img 
            src="/logo.png" 
            alt="Logo" 
            class="logo-public mb-2"
            style="max-height: 60px;"
          >
          <h3 class="title-public mb-1">
            <i class="nc-icon nc-email-85"></i> Sistema de Sugerencias
          </h3>
          <p class="subtitle-public text-muted mb-1" style="font-size: 0.95rem;">
            Comparte tus ideas, felicitaciones o reclamos con nosotros
          </p>
          <p class="text-muted mb-0" style="font-size: 0.9rem;">
            <strong>{{ nombreEmpresa }}</strong>{{ nombreSucursal ? ` - ${nombreSucursal}` : '' }}
          </p>
        </div>
      </div>
    </div>

    <!-- Formulario -->
    <div class="container py-4">
      <div class="row justify-content-center">
        <div class="col-lg-8 col-md-10">
          <div class="card shadow-lg">
            <div class="card-body p-4">
              <h4 class="card-title mb-4">
                <i class="nc-icon nc-paper"></i> Nueva Sugerencia
              </h4>

              <!-- Tipo de Mensaje -->
              <div class="form-group">
                <label>Tipo de Mensaje <span class="text-danger">*</span></label>
                <div class="row">
                  <div class="col-6 col-md-3 mb-2">
                    <button
                      type="button"
                      :class="['btn btn-block tipo-btn', form.tipo === 'SUGERENCIA' ? 'btn-primary active' : 'btn-outline-primary']"
                      @click="form.tipo = 'SUGERENCIA'"
                    >
                      💡 Sugerencia
                    </button>
                  </div>
                  <div class="col-6 col-md-3 mb-2">
                    <button
                      type="button"
                      :class="['btn btn-block tipo-btn', form.tipo === 'FELICITACIÓN' ? 'btn-success active' : 'btn-outline-success']"
                      @click="form.tipo = 'FELICITACIÓN'"
                    >
                      👍 Felicitación
                    </button>
                  </div>
                  <div class="col-6 col-md-3 mb-2">
                    <button
                      type="button"
                      :class="['btn btn-block tipo-btn', form.tipo === 'RECLAMO' ? 'btn-danger active' : 'btn-outline-danger']"
                      @click="form.tipo = 'RECLAMO'"
                    >
                      ⚠️ Reclamo
                    </button>
                  </div>
                  <div class="col-6 col-md-3 mb-2">
                    <button
                      type="button"
                      :class="['btn btn-block tipo-btn', form.tipo === 'OTRO' ? 'btn-secondary active' : 'btn-outline-secondary']"
                      @click="form.tipo = 'OTRO'"
                    >
                      💬 Otro
                    </button>
                  </div>
                </div>
                <small class="form-text text-muted">
                  Selecciona el tipo de mensaje que deseas enviar
                </small>
              </div>

              <!-- Nombre y Switch Anónimo -->
              <div class="row">
                <div class="col-md-8">
                  <div class="form-group">
                    <label>Tu Nombre</label>
                    <input
                      v-model="form.nombreSocio"
                      type="text"
                      class="form-control"
                      placeholder="Ej: Juan Pérez"
                      maxlength="100"
                      :disabled="enviando || form.anonimo"
                    >
                    <small class="form-text text-muted">
                      {{ form.anonimo ? 'Enviando como anónimo' : 'Opcional - déjalo vacío si prefieres ser anónimo' }}
                    </small>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>&nbsp;</label>
                    <div class="custom-control custom-switch" style="padding-top: 10px;">
                      <input
                        v-model="form.anonimo"
                        type="checkbox"
                        class="custom-control-input"
                        id="switchAnonimo"
                        :disabled="enviando"
                      >
                      <label class="custom-control-label" for="switchAnonimo">
                        <i class="nc-icon nc-lock-circle-open"></i> Anónimo
                      </label>
                    </div>
                    <small class="form-text text-muted">
                      Ocultar mi identidad
                    </small>
                  </div>
                </div>
              </div>

              <!-- Asunto -->
              <div class="form-group">
                <label>Asunto <span class="text-danger">*</span></label>
                <input
                  v-model="form.asunto"
                  type="text"
                  class="form-control"
                  placeholder="Ej: Mejora en los horarios de clases"
                  maxlength="200"
                  :disabled="enviando"
                >
                <small class="form-text text-muted">
                  {{ form.asunto.length }} / 200 caracteres
                </small>
              </div>

              <!-- Mensaje -->
              <div class="form-group">
                <label>Mensaje <span class="text-danger">*</span></label>
                <textarea
                  v-model="form.mensaje"
                  class="form-control"
                  rows="6"
                  placeholder="Describe aquí tu sugerencia, felicitación o reclamo de manera clara y detallada..."
                  maxlength="2000"
                  :disabled="enviando"
                ></textarea>
                <small class="form-text text-muted">
                  {{ form.mensaje.length }} / 2000 caracteres
                </small>
              </div>

              <!-- Información de Privacidad -->
              <div class="alert alert-info">
                <i class="nc-icon nc-alert-circle-i"></i>
                <strong>Información:</strong>
                Tu mensaje será enviado al equipo administrativo del gimnasio. 
                <span v-if="form.anonimo">
                  Tu identidad permanecerá <strong>anónima</strong>.
                </span>
                <span v-else>
                  {{ form.nombreSocio ? `Se enviará con el nombre: "${form.nombreSocio}"` : 'Puedes agregar tu nombre arriba o dejarlo vacío para ser anónimo.' }}
                </span>
              </div>

              <!-- Botones -->
              <div class="d-flex justify-content-between">
                <button
                  type="button"
                  class="btn btn-secondary"
                  @click="limpiarFormulario"
                  :disabled="enviando"
                >
                  <i class="nc-icon nc-simple-remove"></i> Limpiar
                </button>
                <button
                  type="button"
                  class="btn btn-success btn-lg"
                  @click="enviarSugerencia"
                  :disabled="!validarFormulario() || enviando"
                >
                  <span v-if="!enviando">
                    <i class="nc-icon nc-send"></i> Enviar Sugerencia
                  </span>
                  <span v-else>
                    <i class="fa fa-spinner fa-spin"></i> Enviando...
                  </span>
                </button>
              </div>
            </div>
          </div>

          <!-- Footer -->
          <div class="text-center mt-4 mb-4">
            <div class="badge badge-light p-3" style="font-size: 0.9rem; font-weight: normal;">
              <i class="nc-icon nc-lock-circle-open"></i> 
              Tus datos están protegidos. Solo el gimnasio podrá ver tu mensaje.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2';

export default {
  name: 'SugerenciasPublicas',
  
  data() {
    return {
      // Parámetros de URL
      token: null,
      idSucursal: null,
      nombreEmpresa: 'Gimnasio',
      nombreSucursal: '',
      
      // Formulario
      form: {
        tipo: 'SUGERENCIA',
        nombreSocio: '',
        asunto: '',
        mensaje: '',
        anonimo: false
      },
      
      // Estado
      enviando: false
    };
  },

  mounted() {
    this.obtenerParametrosURL();
    this.validarAcceso();
  },

  methods: {
    /**
     * Obtener parámetros de la URL
     */
    obtenerParametrosURL() {
      const urlParams = new URLSearchParams(window.location.search);
      this.token = urlParams.get('token');
      this.idSucursal = urlParams.get('s');
      
      // Los nombres de empresa y sucursal se pueden obtener después mediante una consulta al backend
      // Por ahora solo usamos los valores por defecto
      this.nombreEmpresa = 'Gimnasio';
      this.nombreSucursal = '';
    },

    /**
     * Validar que el acceso sea válido
     */
    validarAcceso() {
      if (!this.token || !this.idSucursal) {
        Swal.fire({
          icon: 'error',
          title: 'Acceso No Válido',
          text: 'Este enlace no es válido o ha expirado. Por favor, solicita un nuevo enlace al gimnasio.',
          confirmButtonColor: '#ef5350',
          allowOutsideClick: false
        }).then(() => {
          // Redirigir a página principal o cerrar
          window.close();
        });
      }
    },

    /**
     * Validar formulario
     */
    validarFormulario() {
      return this.form.tipo && 
             this.form.asunto.trim().length >= 5 && 
             this.form.mensaje.trim().length >= 10;
    },

    /**
     * Limpiar formulario
     */
    limpiarFormulario() {
      this.form = {
        tipo: 'SUGERENCIA',
        nombreSocio: '',
        asunto: '',
        mensaje: '',
        anonimo: false
      };
    },

    /**
     * Enviar sugerencia
     */
    async enviarSugerencia() {
      if (!this.validarFormulario()) {
        Swal.fire({
          icon: 'warning',
          title: 'Datos Incompletos',
          text: 'Por favor completa todos los campos requeridos.',
          confirmButtonColor: '#ffa726'
        });
        return;
      }

      this.enviando = true;

      try {
        const payload = {
          Header: {
            Operacion: '/v1/sugerencias-publicas/crear'
          },
          Body: {
            token: this.token,
            s: this.idSucursal,
            nombreSocio: this.form.anonimo ? '' : this.form.nombreSocio.trim(),
            tipo: this.form.tipo,
            asunto: this.form.asunto.trim(),
            mensaje: this.form.mensaje.trim(),
            anonimo: this.form.anonimo
          }
        };

        // Usar instancia pública sin interceptor de tokens
        const response = await this.$CentralGymOPS_API_Public.post('/v1/sugerencias-publicas/crear', payload);

        if (response.data.result && response.data.result.status === 'success') {
          // Éxito
          await Swal.fire({
            icon: 'success',
            title: '¡Enviado!',
            html: `
              <p>Tu ${this.form.tipo.toLowerCase()} ha sido enviada exitosamente.</p>
              <p class="text-muted">El equipo del gimnasio la revisará y te responderá a la brevedad.</p>
            `,
            confirmButtonColor: '#6bd098',
            confirmButtonText: 'Entendido'
          });

          // Limpiar formulario
          this.limpiarFormulario();
        }
      } catch (error) {
        console.error('Error al enviar sugerencia:', error);
        
        let mensajeError = 'No se pudo enviar tu sugerencia. Por favor, intenta nuevamente.';
        
        if (error.response && error.response.data && error.response.data.result) {
          mensajeError = error.response.data.result.message || mensajeError;
        }

        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: mensajeError,
          confirmButtonColor: '#ef5350'
        });
      } finally {
        this.enviando = false;
      }
    }
  }
};
</script>

<style scoped>
.sugerencias-publicas-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.header-public {
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.logo-public {
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}

.title-public {
  color: #333;
  font-weight: 700;
}

.subtitle-public {
  font-size: 1.1rem;
}

.card {
  border: none;
  border-radius: 15px;
}

.tipo-btn {
  transition: all 0.3s ease;
  border-width: 2px;
  font-weight: 600;
}

.tipo-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.tipo-btn.active {
  transform: scale(1.05);
}

.form-control {
  border-radius: 8px;
  border: 2px solid #e0e0e0;
  transition: all 0.3s ease;
}

.form-control:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.25);
}

textarea.form-control {
  resize: vertical;
  min-height: 150px;
}

.custom-control-label {
  cursor: pointer;
  user-select: none;
}

.alert-info {
  background-color: #e3f2fd;
  border-color: #90caf9;
  color: #1976d2;
  border-radius: 8px;
}

.btn-lg {
  padding: 0.75rem 2rem;
  font-size: 1.1rem;
  border-radius: 8px;
}

/* Scrollbar personalizado */
textarea::-webkit-scrollbar {
  width: 8px;
}

textarea::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

textarea::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

textarea::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Animaciones */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.card {
  animation: fadeIn 0.5s ease;
}

/* Responsive */
@media (max-width: 768px) {
  .header-public .text-center {
    padding: 1rem 0 !important;
  }
  
  .title-public {
    font-size: 1.3rem;
  }
  
  .subtitle-public {
    font-size: 0.85rem !important;
  }
  
  .logo-public {
    max-height: 50px !important;
  }
}
</style>

